import React, { useState } from "react";
import {
    Grid,
    IconButton,
    Backdrop,
    CircularProgress,
} from "@material-ui/core";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack, Error } from "@mui/icons-material";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../CustomSnackbar";
import ReportTable from "./ReportTable.js";
import InvoiceReturnTable from "./reportTables/InvoiceReturnTable.js";
import ReturnToReprocessing from "./reportTables/ReturnToReprocessing.js";

const useStyles = makeStyles(dashboardStyle);
const commentBox = {
    fontFamily: "DM Sans,sans-serif",
    fontWeight: "400",
    fontSize: "0.875rem",
    width: "100%",
    border: "1px solid #b4b4b4",
    borderRadius: "2px",
    resize: "none",
    overflow: "hidden",
    outline: "none",
    height: "40px",
    marginTop: "1px",
    color: "black",
};
const headers = [
    { label: "Invoice No", key: "invoiceNo" },
    { label: "Invoice Date", key: "invoiceDate" },
    { label: "Vendor Code", key: "vendorCode" },
    { label: "Vendor Name", key: "vendorName" },
    { label: "Invoice Type", key: "invoiceType" },
    { label: "Submission Date", key: "submissionDate" },
    { label: "Return Date", key: "returnDate" },
    { label: "Return By (User Name)", key: "returnBy" },
    { label: "Return By Stage", key: "returnByStage" },
    { label: "Return to Stage", key: "returnToStage" },
    { label: "Return To", key: "returnTo" },
    { label: "Reason ", key: "reason" },

];

export default function InvoiceReturnToPreProcessing() {
    const classes = useStyles();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sendloader, setSendloader] = useState(false);

    const [countNo, setCountNo] = React.useState(1); // Set default page to 0

    return (
        <div>
            {" "}
            <>
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={sendloader}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Card style={{ marginLeft: "20px" }}>
                    <CardHeader color="primary" text>
                        <CardText
                            style={{
                                padding: "1px 27px",
                                backgroundColor: "#031C30",
                                color: "white",
                                height: "62px",
                            }}
                        >
                            <Grid container justifyContent="space-between">
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <h4>Invoice return to Reprocessing</h4>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <IconButton
                                        variant="contained"
                                        style={{ float: "right", marginTop: "1.5%" }}
                                        onClick={() => navigate("/home")}
                                    >
                                        <ArrowBack
                                            style={{ color: "#fff" }}
                                            titleAccess="Go Back"
                                        />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </CardText>
                    </CardHeader>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <ReturnToReprocessing
                            loading={loading}
                            setCountNo={setCountNo}
                            header={headers}
                            data={data}
                            dropdownValue={"InvoiceType"}
                            setData={setData}
                            setLoading={setLoading}
                        />
                    </Grid>
                </Card>
            </>
        </div>
    );
}
